export const createConditionReport = () => {
    return {
        testReport: ({ modelRef }) => {
            const report = {}
            const labTypeKey = modelRef.refLabType?.key;
            const samplingRequestTypeKey = modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key;
            const provinceCode = modelRef.refDepartment?.refProvince?.code;
            if (labTypeKey === 'labMicro') {
                report.group = 'LAB_MICRO';
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'test_report_monitor_micro'
                } else {
                    report.key = 'test_report_micro_bangkok'
                }
            } else if (labTypeKey === 'labChemi') {
                report.group = 'LAB_CHEMI'
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'test_report_monitor_chemi'
                } else {
                    if (provinceCode === '74') { // Samut Sakhon
                        report.key = 'test_report_chemi_samutsakorn'
                    } else if (provinceCode === '84') { // Surat Thani
                        report.group = 'LAB_CHEMI';
                        report.key = 'test_report_chemi_micro_suratthani'
                    } else if (provinceCode === '90') { // Songkhla
                        report.key = 'test_report_chemi_songkhla'
                    } else { // Bangkok
                        report.key = 'test_report_chemi'
                    }
                }
            } else if (labTypeKey === 'labPhysic') {
                report.group = 'LAB_PHYSIC';
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'test_report_monitor_physic'
                } else {
                    report.key = 'test_report_physic'
                }
            }
            return report;
        },
        suspendForm: ({ modelRef }) => {
            const report = {}
            const labTypeKey = modelRef.refLabType?.key;
            if (labTypeKey === 'labMicro') {
                report.group = 'LAB_MICRO'
                report.key = 'suspend_form_micro'
            } else if (labTypeKey === 'labChemi') {
                report.group = 'LAB_CHEMI'
                report.key = 'suspend_form_chemi'
            } else if (labTypeKey === 'labPhysic') {
                report.group = 'LAB_PHYSIC'
                report.key = 'suspend_form_physic'
            }
            return report;
        },
        rejectionForm: ({ modelRef }) => {
            const report = {}
            const labTypeKey = modelRef.refLabType?.key;
            const samplingRequestTypeKey = modelRef.refSamplingProduct?.refSamplingRequest?.refSamplingRequestType?.key;
            if (labTypeKey === 'labMicro') {
                report.group = 'LAB_MICRO';
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'reject_form_monitor_micro'
                } else {
                    report.key = 'reject_form_micro'
                }
            } else if (labTypeKey === 'labChemi') {
                report.group = 'LAB_CHEMI'
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'reject_form_monitor_chemi'
                } else {
                    report.key = 'reject_form_chemi'
                }
            } else if (labTypeKey === 'labPhysic') {
                report.group = 'LAB_PHYSIC';
                if (samplingRequestTypeKey === 'M') {
                    report.key = 'reject_form_monitor_physic'
                } else {
                    report.key = 'reject_form_physic'
                }
            }
            return report;
        },

    }
}